export const labels = {
  advisorCommissionTiers: {
    min_monthly_premium: 'PRIMA MÍN',
    max_monthly_premium: 'PRIMA MAX',
  },
};
export const t = (path) => path.split('.').reduce((o, k) => (o ? o[k] : undefined), labels) ?? path;